import { render, staticRenderFns } from "./SenderVerify.vue?vue&type=template&id=467a4766&"
import script from "./SenderVerify.vue?vue&type=script&lang=js&"
export * from "./SenderVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports